// M1 — Rule Authoring testids
export const RULES = {
  // Navigation / brand scope picker
  navLink: "nav-rules-link",
  brandPickerHint: "rules-brand-picker-hint",

  // Rule list
  listRoot: "rules-list-root",
  newRuleButton: "rules-new-button",
  statusFilter: "rules-status-filter",
  rowPrefix: "rule-row-", // append rule_id

  // Author screen (Surface A)
  authorRoot: "rule-author-root",
  surfaceAInput: "rule-author-input",
  surfaceAParseButton: "rule-author-parse-button",
  surfaceAOpenStructured: "rule-author-open-structured-button",
  parseSpinner: "rule-author-parse-spinner",
  refusalBanner: "rule-author-refusal-banner",

  // Per-proposal confirmation
  proposalPrefix: "rule-proposal-", // append index
  proposalTypeSelect: "rule-proposal-type-select-",
  proposalSeveritySelect: "rule-proposal-severity-select-",
  proposalExplanationInput: "rule-proposal-explanation-input-",
  proposalParamsTextarea: "rule-proposal-params-textarea-",
  proposalScopeFormats: "rule-proposal-scope-formats-",
  proposalScopePanels: "rule-proposal-scope-panels-",
  proposalAcceptButton: "rule-proposal-accept-",
  proposalRejectButton: "rule-proposal-reject-",
  proposalSaveAsNote: "rule-proposal-save-as-note-",

  // Detail
  detailRoot: "rule-detail-root",
  detailEditButton: "rule-detail-edit-button",
  detailTestButton: "rule-detail-test-button",
  detailActivateButton: "rule-detail-activate-button",
  detailRetireButton: "rule-detail-retire-button",
  detailTestDocSelect: "rule-detail-test-doc-select",
  detailFindings: "rule-detail-findings",
  detailConflicts: "rule-detail-conflicts",
  detailHistory: "rule-detail-history",
};
